import * as brandRabbitAnimation from "../brandRabbitAnimation";

const initialize = () => {
  const root = document.querySelector<HTMLElement>(".rabbitAnimation");
  if (!root) return;
  const motion = root.querySelector<HTMLInputElement>(".motionToggle");
  const override = root.querySelector<HTMLInputElement>(".reducedMotionToggle");
  const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
  let loading = false;

  const startWhenRequested = async () => {
    if (
      loading ||
      !(preference.matches
        ? override?.checked ?? false
        : motion?.checked ?? true)
    ) {
      return;
    }
    loading = true;
    try {
      // Keep the resting cel visible until every action is decoded. Reduced
      // motion loads only that first sheet unless the visitor opts into play.
      await Promise.all(
        [
          "rabbit-page-turn-sheet-v4.webp",
          "rabbit-feet-twiddle-sheet-v2.webp",
          "rabbit-ear-twitch-sheet-v2.webp",
        ].map(async (filename) => {
          const image = new Image();
          image.src = `/content/landingPages/${filename}`;
          await image.decode();
        })
      );
      motion?.removeEventListener("change", startWhenRequested);
      override?.removeEventListener("change", startWhenRequested);
      preference.removeEventListener("change", startWhenRequested);
      brandRabbitAnimation.startRabbitAnimation(root);
    } catch {
      // Leave a readable still; toggling play retries a failed download.
      loading = false;
      if (motion) motion.checked = false;
      if (override) override.checked = false;
    }
  };

  motion?.addEventListener("change", startWhenRequested);
  override?.addEventListener("change", startWhenRequested);
  preference.addEventListener("change", startWhenRequested);
  void startWhenRequested();
};

initialize();
